import React from 'react';
import { Loader2 } from 'lucide-react';
import ListingCard from './ListingCard';
import { useApp } from '../context/AppContext';

export const ListingGrid = ({ listings, loading, error, compact = false, cols = 'grid-cols-2 lg:grid-cols-4', emptyText, testId, onRetry }) => {
  const { t } = useApp();
  if (loading) {
    return <div className="flex justify-center py-16" data-testid="listings-loading"><Loader2 className="w-8 h-8 animate-spin text-[#0F8B5C]" /></div>;
  }
  if (error) {
    return (
      <div className="text-center py-12 text-[#7A7468]" data-testid="listings-error">
        <p>{t('common.error')}</p>
        {onRetry && <button onClick={onRetry} className="mt-3 text-sm font-semibold text-[#0F8B5C] hover:underline">{t('common.retry')}</button>}
      </div>
    );
  }
  if (!listings?.length) {
    return <div className="text-center py-12 text-[#7A7468]" data-testid="listings-empty">{emptyText || t('mkt.noResults')}</div>;
  }
  return (
    <div className={`grid ${cols} gap-4 md:gap-6`} data-testid={testId}>
      {listings.map((l) => <ListingCard key={l.id} listing={l} compact={compact} />)}
    </div>
  );
};
